import { render } from "./IMIVVitaminTherapiesContentEs.vue?vue&type=template&id=920a2d94"
import script from "./IMIVVitaminTherapiesContentEs.vue?vue&type=script&lang=js"
export * from "./IMIVVitaminTherapiesContentEs.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__